import { observer } from 'mobx-react'
import { useMemo, useState } from 'react'

import { TableFilterContext } from './TableContext'

const TableFilterContainer = ({
  children,
  defaultShowFilterSection = false,
  onToggleFilter = (value: boolean) => {},
  handleSearch,
  handleRefresh,
  handleReset,
  showFilterInPlace = false, // Place filter section above table instead of popup
}) => {
  const [showFilterSection, setShowFilterSection] = useState(
    defaultShowFilterSection
  )

  const handleChangeShowFilterSection = value => {
    setShowFilterSection(value)
    onToggleFilter && onToggleFilter(value)
  }

  const handleApply = (data: any) => {
    setShowFilterSection(false)
    onToggleFilter && onToggleFilter(false)
  }

  const handleCancel = () => {
    setShowFilterSection(false)
    onToggleFilter && onToggleFilter(false)
  }

  const contextValue = useMemo(
    () => ({
      isShowFilterSection: showFilterSection,
      setShowFilterSection: handleChangeShowFilterSection,
      onApply: handleApply,
      onCancel: handleCancel,
      handleSearch,
      handleRefresh,
      handleReset,
      showFilterInPlace,
    }),
    [showFilterSection, setShowFilterSection]
  )
  return (
    <TableFilterContext.Provider value={contextValue}>
      {children}
    </TableFilterContext.Provider>
  )
}
export default observer(TableFilterContainer)
